import type { PermissionCode } from 'shared/permissions'

const sessionEdit: PermissionCode = 'SESSION_CAN_EDIT'
const sessionView: PermissionCode = 'SESSION_CAN_VIEW_LIST'

export const permissions = {
  catalog: ['CATALOG_CAN_SEE_CATALOG'],
  accreditation: ['ACCREDITATION_CAN_SEE_CATALOG'],
  trainingManagement: ['CATALOG_CAN_VIEW_TRAINING'],
  trainingManagementEdit: ['CATALOG_MANAGEMENT', 'CATALOG_CAN_CREATE_TRAINING'],
  myPerimeter: ['PERIMETER_CAN_VIEW'],
  needsSummary: ['TRAINING_WISH_CAN_VIEW'],
  sessions: [sessionEdit, sessionView],
  sessionEdit: [sessionEdit],
  sessionEditTask: ['SESSION_CAN_EDIT_TASK'],
  sessionView: [sessionView],
  sessionViewTask: ['SESSION_CAN_VIEW_TASK'],
  trainingPlan: ['TRAINING_PLAN_CAN_VIEW'],
  trainingPlanPassportExport: ['TRAINING_PLAN_CAN_EXPORT_PREVENTION_PASSPORT'],
  trainingHistory: ['TRAINING_HISTORY_CAN_VIEW'],
  deletedWishes: ['ADMIN_REMOVED_TRAINING_WISH'],
  accreditationBoard: ['ACCREDITATION_CAN_SEE_WISH', 'ACCREDITATION_CAN_SEE_ORIENTATION'],
  renewableTrainingBoard: ['RENEWABLE_TRAINING_DASHBOARD'],
  collectives: ['COLLECTIVE_CAN_VIEW'],
  reporting: ['PARTNERS_REPORTING'],
  adminProfiles: ['ADMIN_MANAGE_PROFILE'],
  adminSubProfiles: ['ADMIN_MANAGE_PROFILE'],
  adminSettings: ['ADMIN_SETTINGS'],
  adminCollaborators: ['ADMIN_COLLABORATORS'],
  adminDocTemplates: ['ADMIN_DOC_TEMPLATE'],
  adminPopulations: ['ADMIN_POPULATIONS'],
  adminApplications: ['ADMIN_SETTINGS'],
  adminTrainings: ['ADMIN_TRAININGS'],
  adminWishes: ['ADMIN_WISH'],
  adminWishCost: ['ADMIN_WISH_COST'],
  priorities: ['TRAINING_WISH_CAN_VIEW_PRIORITY'],
  adminVintages: ['ADMIN_VINTAGE'],
  adminSessionTrainingRooms: ['SESSION_ADMIN_TRAINING_ROOMS'],
  adminSessionManagement: ['SESSION_ADMIN_MANAGEMENT'],
  adminSessionCancelationReasons: ['SESSION_ADMIN_MANAGEMENT'],
  adminSessionAbsenceReasons: ['SESSION_ADMIN_MANAGEMENT'],
  adminSessionParticipantInformation: ['SESSION_ADMIN_MANAGEMENT'],
  adminSessionCosts: ['SESSION_ADMIN_MANAGEMENT'],
  adminCustomFields: ['ADMIN_CUSTOM_FIELDS'],
  adminAnimationLocales: ['SESSION_ADMIN_MANAGEMENT'],
  adminSessionTypes: ['SESSION_ADMIN_MANAGEMENT'],
  adminSessionLocations: ['SESSION_ADMIN_MANAGEMENT'],
  adminSessionTasks: ['SESSION_CAN_EDIT_TASK'],
  adminTrainingPlan: ['ADMIN_TRAINING_PLAN'],
  adminUsersOrganizations: ['ADMIN_USERS_AND_ORGANIZATIONS'],
  adminMatrix: ['ADMIN_MATRIX'],
  adminSurveys: ['ADMIN_SURVEY'],
  adminSurveysCanEdit: ['SURVEY_CAN_EDIT'],
  adminEmailTemplates: ['ADMIN_EMAIL_TEMPLATE'],
  adminEmailScheduled: ['EMAIL_MONITOR'],
  adminEmailSent: ['EMAIL_MONITOR'],
  adminImports: ['ADMIN_IMPORT_CREATE', 'ADMIN_IMPORT_UPDATE', 'ADMIN_USER_IMPORT'],
  configurableExports: ['EXPORT_CONFIGURABLE_CAN_EDIT_CREATE'],
  adminAutomations: ['ADMIN_AUTOMATION'],
  adminAccreditationManagement: ['ACCREDITATION_MANAGEMENT'],
  adminPerimetersTraining: ['ADMIN_TRAINING_PERIMETER'],
  adminPerimetersAccreditation: ['ADMIN_ACCREDITATION_PERIMETER'],
  roomBookingCanView: ['ROOM_BOOKING_CAN_VIEW'],
  roomBookingCanAdd: ['ROOM_BOOKING_CAN_ADD'],
  roomBookingCanDelete: ['ROOM_BOOKING_CAN_DELETE'],
} satisfies Record<string, PermissionCode[]>
